/* ============================================================
   SKINEETI — custom section behaviour for the Dawn-based theme
   Every init function is safe to call again: the Shopify editor
   re-renders sections, so we re-run init on section load.
   ============================================================ */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var FINE = window.matchMedia('(pointer: fine)').matches;
  if (DESIGN) document.documentElement.classList.add('shopify-design-mode');
  var FX = document.body ? document.body.dataset : {};

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['__skn_' + key]) return false; el['__skn_' + key] = true; return true; }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    $all('[data-skn-hero]', root).forEach(function (hero) {
      if (!once(hero, 'hero')) return;
      var slides = $all('.hero-slide', hero);
      var dots = $all('.hero-dots button', hero);
      if (slides.length < 2) { slides.forEach(function (s) { s.classList.add('active'); }); return; }
      var idx = 0, timer, speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
      function show(i) {
        idx = i;
        slides.forEach(function (s, j) { s.classList.toggle('active', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      }
      function restart() { clearInterval(timer); if (!DESIGN && hero.dataset.autoplay !== 'false') timer = setInterval(function () { show((idx + 1) % slides.length); }, speed); }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); restart(); }); });
      hero.__sknShow = function (i) { show(i); clearInterval(timer); };
      restart();
    });
  }

  /* ---------- Rotating announcement ---------- */
  function initAnnounce(root) {
    $all('[data-skn-announce]', root).forEach(function (bar) {
      if (!once(bar, 'ann')) return;
      var spans = $all('.a-rot > span', bar);
      if (spans.length < 2 || REDUCED) return;
      var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      setInterval(function () {
        spans[i].classList.remove('active');
        i = (i + 1) % spans.length;
        spans[i].classList.add('active');
      }, speed);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  function initReveal(root) {
    $all('.skn .reveal', root).forEach(function (el) {
      if (!revealObs || DESIGN || REDUCED) { el.classList.add('visible'); return; }
      if (once(el, 'rev')) revealObs.observe(el);
    });
  }

  /* ---------- Word-by-word headline reveal ---------- */
  function splitWords(node) {
    Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
      if (ch.nodeType === 3) {
        var frag = document.createDocumentFragment();
        ch.textContent.split(/(\s+)/).forEach(function (tok) {
          if (!tok) return;
          if (/^\s+$/.test(tok)) frag.appendChild(document.createTextNode(tok));
          else { var s = document.createElement('span'); s.className = 'w'; s.textContent = tok; frag.appendChild(s); }
        });
        node.replaceChild(frag, ch);
      } else if (ch.nodeType === 1 && ch.tagName !== 'BR') splitWords(ch);
    });
  }
  function initWords(root) {
    if (REDUCED || DESIGN || !('IntersectionObserver' in window)) return;
    var heads = $all('.skn .section-head h2, .skn .film h2', root).filter(function (h) { return once(h, 'wr'); });
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
    }, { threshold: 0.3 });
    heads.forEach(function (h) {
      splitWords(h); h.classList.add('wr');
      $all('.w', h).forEach(function (w, i) { w.style.transitionDelay = (i * 0.045) + 's'; });
      obs.observe(h);
    });
  }

  /* ---------- Counters ---------- */
  function initCounters(root) {
    var nums = $all('.skn .stat-num[data-count]', root).filter(function (n) { return once(n, 'cnt'); });
    if (!nums.length) return;
    function run(el) {
      var end = parseFloat(el.dataset.count) || 0, suffix = el.dataset.suffix || '';
      if (REDUCED || DESIGN) { el.textContent = end + suffix; return; }
      var t0 = performance.now(), dur = 1400;
      (function tick(t) {
        var p = Math.min(1, (t - t0) / dur);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { run(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---------- Floating petals ---------- */
  function initPetals(root) {
    $all('.skn .film[data-petals="true"]', root).forEach(function (film) {
      if (!once(film, 'pet') || REDUCED) return;
      for (var i = 0; i < 14; i++) {
        var p = document.createElement('span'), size = 6 + Math.random() * 16;
        p.className = 'petal';
        p.style.width = size + 'px'; p.style.height = size + 'px';
        p.style.left = Math.random() * 100 + '%';
        p.style.animationDuration = (9 + Math.random() * 12) + 's';
        p.style.animationDelay = (-Math.random() * 18) + 's';
        p.style.opacity = (0.25 + Math.random() * 0.5).toFixed(2);
        film.appendChild(p);
      }
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery(root) {
    $all('.skn .pdp-gallery', root).forEach(function (g) {
      if (!once(g, 'gal')) return;
      var t = g.querySelector('.pg-track');
      if (!t) return;
      var thumbs = $all('.pg-thumbs button', g);
      function go(dir) { t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' }); }
      $all('.pg-nav', g).forEach(function (b) { b.addEventListener('click', function () { go(b.classList.contains('prev') ? -1 : 1); }); });
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' }); }); });
      t.addEventListener('scroll', function () {
        var i = Math.round(t.scrollLeft / t.clientWidth);
        thumbs.forEach(function (b, j) { b.classList.toggle('active', j === i); });
      }, { passive: true });
      g.__sknGo = function (i) { t.scrollTo({ left: i * t.clientWidth }); };
    });
  }

  /* ---------- Instagram lightbox ---------- */
  var IG_GLYPH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4.2"/><circle cx="17.2" cy="6.8" r="1.2" fill="currentColor" stroke="none"/></svg>';
  var ig = { posts: [], idx: 0, handle: '', url: '', modal: null };
  function igRender() {
    var p = ig.posts[ig.idx]; if (!p) return;
    ig.modal.querySelector('.ig-art').innerHTML = p.img ? '<img src="' + p.img + '" alt="">' : '';
    ig.modal.querySelector('.ig-body').innerHTML = '<strong>' + ig.handle + '</strong>&ensp;' + p.cap;
    ig.modal.querySelector('.d').textContent = p.date;
  }
  function igClose() { document.body.classList.remove('ig-open'); }
  function igNav(d) { ig.idx = (ig.idx + d + ig.posts.length) % ig.posts.length; igRender(); }
  function igBuild() {
    if (ig.modal) return;
    var wrap = document.createElement('div');
    wrap.className = 'skn';
    wrap.innerHTML = '<div class="ig-modal" role="dialog" aria-modal="true">' +
      '<button class="ig-close" aria-label="Close">×</button>' +
      '<button class="ig-nav prev" aria-label="Previous">‹</button><button class="ig-nav next" aria-label="Next">›</button>' +
      '<div class="ig-box"><div class="ig-media"><div class="ig-art"></div></div><div class="ig-panel">' +
      '<div class="ig-head"><div class="ig-avatar">S</div><div class="ig-handle"><span class="h"></span><span class="sub"></span></div><a class="ig-follow" target="_blank" rel="noopener">Follow</a></div>' +
      '<div class="ig-body"></div><div class="ig-foot"><span class="d"></span><a class="ig-view" target="_blank" rel="noopener">View on Instagram</a></div>' +
      '</div></div></div>';
    document.body.appendChild(wrap);
    ig.modal = wrap.querySelector('.ig-modal');
    ig.modal.querySelector('.ig-close').onclick = igClose;
    ig.modal.querySelector('.prev').onclick = function () { igNav(-1); };
    ig.modal.querySelector('.next').onclick = function () { igNav(1); };
    ig.modal.addEventListener('click', function (e) { if (e.target === ig.modal) igClose(); });
    document.addEventListener('keydown', function (e) {
      if (!document.body.classList.contains('ig-open')) return;
      if (e.key === 'Escape') igClose();
      if (e.key === 'ArrowLeft') igNav(-1);
      if (e.key === 'ArrowRight') igNav(1);
    });
  }
  function initIG(root) {
    $all('.skn [data-skn-ig]', root).forEach(function (grid) {
      if (!once(grid, 'ig')) return;
      var tiles = $all('.ig-tile', grid);
      tiles.forEach(function (tile, i) {
        function open() {
          igBuild();
          ig.handle = grid.dataset.handle || '';
          ig.url = grid.dataset.url || '#';
          ig.posts = tiles.map(function (t) { return { img: t.dataset.full, cap: t.querySelector('.ig-cap p') ? t.querySelector('.ig-cap p').innerHTML : '', date: t.dataset.date || '' }; });
          ig.modal.querySelector('.ig-handle .h').textContent = ig.handle;
          ig.modal.querySelector('.ig-handle .sub').textContent = grid.dataset.sub || '';
          ig.modal.querySelector('.ig-follow').href = ig.url;
          ig.modal.querySelector('.ig-view').href = ig.url;
          ig.modal.querySelector('.ig-avatar').textContent = (ig.handle || 'S').charAt(0).toUpperCase();
          ig.idx = i; igRender();
          document.body.classList.add('ig-open');
        }
        tile.addEventListener('click', open);
        tile.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
      });
    });
  }

  /* ---------- Delegated clicks: accordion, tabs, filters, brand tabs, qty, add to cart ---------- */
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '₹{{amount_no_decimals}}';
    var amount = (cents / 100);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) return Math.round(amount).toLocaleString('en-IN');
      return amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) { if (btn.dataset.fallbackUrl) window.location = btn.dataset.fallbackUrl; return; }
    var qty = 1;
    var form = btn.closest('[data-skn-buy]');
    if (form && btn.dataset.useQty === 'true') {
      var q = form.querySelector('[data-qty-val]');
      qty = q ? parseInt(q.textContent, 10) || 1 : 1;
      var sel = form.querySelector('[data-variant-select]');
      if (sel) variantId = sel.value;
    }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(variantId, 10), quantity: qty }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var label = btn.innerHTML;
    btn.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (data) {
      btn.classList.remove('is-loading');
      if (data.status) {
        btn.textContent = data.description || data.message || 'Could not add';
        setTimeout(function () { btn.innerHTML = label; }, 2600);
        return;
      }
      if (drawer && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    }).catch(function () {
      btn.classList.remove('is-loading');
      var f = btn.closest('form'); if (f) f.submit();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var acc = t.closest('.skn .acc-head');
    if (acc) {
      var item = acc.parentElement; item.classList.toggle('open');
      var plus = acc.querySelector('.plus'); if (plus) plus.textContent = item.classList.contains('open') ? '−' : '+';
      acc.setAttribute('aria-expanded', item.classList.contains('open'));
      return;
    }
    var tab = t.closest('.skn [data-skn-tab]');
    if (tab) {
      var sec = tab.closest('.tabs-sec');
      $all('.ptabs button', sec).forEach(function (b) { b.classList.toggle('active', b === tab); });
      $all('.tab-panel', sec).forEach(function (p) { p.classList.toggle('active', p.dataset.panel === tab.dataset.sknTab); });
      return;
    }
    var flt = t.closest('.skn [data-skn-filter]');
    if (flt) {
      var wrap = flt.closest('.skn');
      $all('[data-skn-filter]', wrap).forEach(function (b) { b.classList.toggle('active', b === flt); });
      var v = flt.dataset.sknFilter;
      $all('[data-regime]', wrap).forEach(function (c) { c.style.display = (v === 'all' || c.dataset.regime === v) ? '' : 'none'; });
      return;
    }
    var bt = t.closest('[data-skn-brand-tab]');
    if (bt) {
      var view = bt.dataset.sknBrandTab;
      $all('[data-skn-brand-tab]').forEach(function (b) { b.classList.toggle('active', b === bt); });
      showBrandView(view, true);
      return;
    }
    var qb = t.closest('.skn [data-qty]');
    if (qb) {
      var holder = qb.closest('[data-skn-buy]').querySelector('[data-qty-val]');
      var n = Math.max(1, Math.min(10, (parseInt(holder.textContent, 10) || 1) + parseInt(qb.dataset.qty, 10)));
      holder.textContent = n;
      return;
    }
    var add = t.closest('.skn [data-skn-add]');
    if (add) { e.preventDefault(); addToCart(add); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.skn [data-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var buy = sel.closest('[data-skn-buy]');
    var price = buy.querySelector('[data-price]');
    if (price && opt.dataset.price) price.textContent = money(parseInt(opt.dataset.price, 10));
    $all('[data-skn-add]').forEach(function (b) {
      b.dataset.variantId = sel.value;
      b.disabled = opt.dataset.available !== 'true';
    });
  });

  /* ---------- Brand page tabs (About / Ingredients) ---------- */
  function showBrandView(view, scroll) {
    var any = document.querySelector('[data-skn-brand-tab]');
    if (!any) return;
    $all('[data-brand-view]').forEach(function (s) {
      var v = s.dataset.brandView;
      if (v === 'always') return;
      var host = s.closest('.shopify-section') || s;
      host.style.display = (DESIGN || v === view) ? '' : 'none';
    });
    if (scroll) window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
    $all('[data-brand-view="' + view + '"] .reveal').forEach(function (el) { el.classList.add('visible'); });
  }
  function initBrandTabs() {
    var first = document.querySelector('[data-skn-brand-tab]');
    if (!first) return;
    var hash = (location.hash || '').replace('#', '');
    var target = document.querySelector('[data-skn-brand-tab][data-anchor="' + hash + '"]') || first;
    $all('[data-skn-brand-tab]').forEach(function (b) { b.classList.toggle('active', b === target); });
    showBrandView(target.dataset.sknBrandTab, false);
  }

  /* ---------- Global motion (toggled in Theme settings → Skineeti effects) ---------- */
  function initGlobal() {
    var l = document.getElementById('loader');
    if (l) {
      if (REDUCED || DESIGN || sessionStorageGet('sk_seen')) l.remove();
      else { sessionStorageSet('sk_seen', '1'); setTimeout(function () { l.remove(); }, 3400); }
    }
    if (FX.sknProgress === 'true') {
      var bar = document.createElement('div'); bar.id = 'scrollbar'; document.body.appendChild(bar);
      window.addEventListener('scroll', function () {
        var h = document.documentElement;
        bar.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + '%';
      }, { passive: true });
    }
    if (FX.sknCursor === 'true' && !REDUCED && FINE && !DESIGN) {
      var dot = document.createElement('div'); dot.id = 'cur';
      var ring = document.createElement('div'); ring.id = 'curR';
      document.body.appendChild(dot); document.body.appendChild(ring);
      document.body.classList.add('has-cursor');
      var rx = -100, ry = -100, tx = -100, ty = -100;
      document.addEventListener('mousemove', function (e) {
        tx = e.clientX; ty = e.clientY; dot.style.left = tx + 'px'; dot.style.top = ty + 'px';
        ring.classList.toggle('cur-big', !!e.target.closest('a, button, .panel, .ig-tile'));
      }, { passive: true });
      (function follow() { rx += (tx - rx) * 0.16; ry += (ty - ry) * 0.16; ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; requestAnimationFrame(follow); })();
    }
    if (FX.sknTop === 'true') {
      var b = document.createElement('button');
      b.id = 'toTop'; b.setAttribute('aria-label', 'Back to top');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
      b.onclick = function () { window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' }); };
      document.body.appendChild(b);
      window.addEventListener('scroll', function () { b.classList.toggle('show', window.scrollY > 700); }, { passive: true });
    }
    // sticky add-to-cart only after the main buy button scrolls away
    var sticky = document.querySelector('.skn .sticky-atc');
    var mainBtn = document.querySelector('.skn .pdp-add');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      sticky.classList.add('is-hidden');
      new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('is-hidden', e.isIntersecting || e.boundingClientRect.top > 0); }); }).observe(mainBtn);
    }
  }
  function initFx(root) {
    if (REDUCED || !FINE || DESIGN) return;
    if (FX.sknTilt === 'true') $all('.skn .pdp-visual', root).forEach(function (el) {
      if (!once(el, 'tilt')) return;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 4) + 'deg)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
    if (FX.sknMagnetic === 'true') $all('.skn .btn', root).forEach(function (b) {
      if (!once(b, 'mag')) return;
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        b.style.transform = 'translate(' + (x * 6) + 'px,' + (y * 5) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }
  function sessionStorageGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessionStorageSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function initAll(root) {
    initHero(root); initAnnounce(root); initReveal(root); initWords(root); initCounters(root);
    initPetals(root); initGallery(root); initIG(root); initFx(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    FX = document.body.dataset;
    initAll(document); initBrandTabs(); initGlobal();
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initBrandTabs(); });
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    var hero = block.closest('[data-skn-hero]');
    if (hero && hero.__sknShow) hero.__sknShow($all('.hero-slide', hero).indexOf(block));
    var g = block.closest('.pdp-gallery');
    if (g && g.__sknGo) g.__sknGo($all('.pg-slide', g).indexOf(block));
    var panel = block.closest('.tab-panel');
    if (panel) { var b = panel.closest('.tabs-sec').querySelector('[data-skn-tab="' + panel.dataset.panel + '"]'); if (b) b.click(); }
  });
})();
